<template>
  <div class="c-personal-wrapper">
    <!-- filter -->
    <staff-filter
      slot="filter"
      @on-custom="onCustomShow"
      :asyning="asyning"
      @on-down="downData"
      @on-refresh="refreshData"
      @on-change="filterData"
    />

    <!-- table  -->
    <Viewport v-model="tableHeight">
      <el-table class="common-el-table-styles" :data="tableData" :height="tableHeight" v-loading="loading" ref="staffDataTable">
        <el-table-column
          v-for="(col, id) in tableCol"
          :key="id"
          :prop="col.key"
          :label="col.title"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
        >
          <template slot-scope="{ row }">
            <span v-if="col.key.indexOf('Rate') > -1">{{ row[col.key] | toPercent }}</span>
            <span v-else-if="!['designerName', 'projectGroupName'].includes(col.key)">
              {{ row[col.key] | toThousands }}
            </span>
            <span v-else>{{ row[col.key] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <Page
        show-total
        show-sizer
        show-elevator
        class="c-table-page pager"
        size="small"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
      />
    </Viewport>
    <!-- 自定义列 -->
    <custom-column
      v-model="customColumnModal"
      name="StaffDataCustomColumn"
      :data="rawTableCols"
      :sub-title="['基础信息']"
      @on-select="onTableColsChange"
    />
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import { HOST_API } from '@/api/config'
import tableMixin from '../designerkpi/mixin_table'
import tableColumns from '../data/staff_columns'
import StaffFilter from './components/staff-filter'
import CustomColumn from '@/components/converter/custom-column2.vue'

import { getPlannerPage, asynPlannerPage } from '@/api/team.model'

export default {
  name: 'Staff',
  mixins: [tableMixin],
  components: { CustomColumn, StaffFilter },
  computed: {
    tableCol() {
      return this.tableColumns.filter((ret) => ret.checked)
    }
  },
  data() {
    return {
      loading: null,
      asyning: null,
      customColumnModal: false,
      tableHeight: 330,
      rawTableCols: tableColumns,
      tableData: [],
      tableColumns: []
    }
  },
  methods: {
    refreshData() {
      this.asyning = true
      asynPlannerPage({
        dateType: this.params.dateType,
        beginTime: this.params.beginTime
      })
        .then((data) => {
          this.asyning = false
          data && this.getData()
        })
        .catch(() => {
          this.asyning = false
        })
    },
    filterData(params) {
      this.pageIndex = 1
      this.getData(params)
    },
    downData() {
      let url = `${HOST_API}/api/ptom/designer/materialDataExport`
      url += `?sessionid=${this.$store.state.token}`
      url += `&dateType=${this.params.dateType}`
      url += `&beginTime=${this.params.beginTime}`
      url += `&peopleType=${2}`
      this.params.projectGroupId > 0 && (url += `&projectGroupId=${this.params.projectGroupId}`)
      this.params.gameGroupId > 0 && (url += `&gameGroupId=${this.params.gameGroupId}`)
      this.params.gameId > 0 && (url += `&gameId=${this.params.gameId}`)
      this.params.order && (url += `&order=${this.params.order}`)
      this.params.sort && (url += `&sort=${this.params.sort}`)
      window.open(url)
    },
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        peopleType: 2
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getPlannerPage(params)
        .then((data) => {
          if (typeof data !== 'symbol') this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.tableData = list
            this.total = total_number || 0
          } else {
            this.tableData = []
            this.total = 0
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.total = 0
        })
    },
    onCustomShow() {
      this.customColumnModal = true
    },
    onTableColsChange(cols) {
      this.tableColumns = cols
      this.customColumnModal = false
    }
  }
}
</script>
<style lang="scss" scoped>
.c-personal-wrapper {
  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
